<template>
  <el-container class="layout">
    <Menu />
    <Content />
  </el-container>
</template>

<script type="text/ecmascript-6">
import Menu from 'components/Layout/Menu'
import Content from 'components/Layout/Content'
// import { mapActions } from 'vuex'

export default {
  mounted() {
    // this.checkBatchNo()
  },
  data () {
    return {

    }
  },
  methods: {
    // ...mapActions(['checkBatchNo'])
  },
  components: {
    Menu,
    Content
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

.layout
  margin 0 auto
  max-width 1920px
  height 100vh
  background #f0f2f5
</style>
